
interface educationArrayProps {
    data: string;
    name: string;
    school: string;
    isTitle: boolean;
}
export const educationArray: educationArrayProps[] = [
    {
        data: '2020-2025',
        name: 'Next.JS, Advanced React, Bootstrap, .Net',
        school: 'Udemy',
        isTitle: false
    },
    {
        data: '2018-2019',
        name: 'React, JS, Redux Course',
        school: 'CodersLab',
        isTitle: false
    },
    {
        data: '2009-2013',
        name: 'MASTER OF ARTS',
        school: 'Academy of Fine Arts in Warsaw / Media Arts Department',
        isTitle: true
    },
    {
        data: '2008',
        name: 'Advanced Photoshop Course',
        school: 'Academy of Photography in Warsaw',
        isTitle: false
    },
    {
        data: '2007 - 2008',
        name: 'Professional Photography Course',
        school: 'Academy of Photography in Warsaw',
        isTitle: false
    },
    {
        data: '2003 - 2006',
        name: 'BACHELOR OF PARAMEDICINE',
        school: 'Medical University of Warsaw',
        isTitle: true
    },
]